import React, { useState } from "react";
import I18n from "i18n-js";

import { REMOVE_COMPONENT } from "../constants";
import { nomenclatureDesignationFromUuid } from "../../../../nomenclatures/utils/nomenclatureUtils";
import { formatDate } from "../../../../common/utils/dateUtils";
import StatelessTable from "../../../../common/components/elements/StatelessTable";
import { array, func, shape } from "prop-types";

InstallationComponentListEdit.propTypes = {
  components: array,
  nomenclaturesList: shape(),
  dispatch: func,
  onAdd: func,
};

export default function InstallationComponentListEdit({
  components,
  nomenclaturesList,
  dispatch,
  onAdd,
}) {
  const {
    componentBrands,
    componentNatureClassifications,
    componentNatureTypes,
    componentNatures,
  } = nomenclaturesList;

  const [currentPage, setCurrentPage] = useState(1);

  function dataTableHead() {
    return [
      I18n.t("pages.installations.view.components.nature:label"),
      I18n.t("pages.installations.view.components.type:label"),
      I18n.t("pages.installations.view.components.category:label"),
      I18n.t("pages.installations.view.components.brand:label"),
      I18n.t("pages.installations.view.components.model:label"),
      I18n.t("pages.installations.view.components.serial-number:label"),
      I18n.t("pages.installations.view.components.mark:label"),
      I18n.t("pages.installations.view.components.designation:label"),
      I18n.t("pages.installations.view.components.barcode:label"),
      I18n.t("pages.installations.view.components.commissioning-date:label"),
      I18n.t("pages.installations.view.components.usage-percent:label"),
    ];
  }

  function dataTableRow(rowData) {
    const {
      nature,
      natureType,
      natureClassification,
      brand,
      model,
      serialNumber,
      mark,
      designation,
      barcode,
      commissioningDate,
      usagePercent,
      deleteable,
    } = rowData;
    return [
      nomenclatureDesignationFromUuid(componentNatures, nature),
      nomenclatureDesignationFromUuid(componentNatureTypes, natureType),
      nomenclatureDesignationFromUuid(
        componentNatureClassifications,
        natureClassification
      ),
      nomenclatureDesignationFromUuid(componentBrands, brand),
      model,
      serialNumber,
      mark,
      designation,
      barcode,
      formatDate(commissioningDate),
      (usagePercent ?? "0") + "%",
      deleteable ? (
        <RowActions
          rowData={rowData}
          removeComponent={(uuid) =>
            dispatch({ type: REMOVE_COMPONENT, payload: uuid })
          }
        />
      ) : null,
    ];
  }

  return (
    <StatelessTable
      className=""
      actions={<ComponentAddButton onAdd={() => onAdd()} />}
      data={components}
      pagination={components?.length > 5 ? true : false}
      perPage={5}
      currentPage={currentPage}
      onPageChanged={(newPage) => {
        setCurrentPage(newPage);
      }}
      headData={dataTableHead()}
      rowData={(data) => dataTableRow(data)}
    />
  );
}

ComponentAddButton.propTypes = {
  onAdd: func,
};

function ComponentAddButton({ onAdd }) {
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        onAdd();
      }}
      className="btn btn-primary"
    >
      {I18n.t("pages.installations.list.actions.add")}
    </button>
  );
}

RowActions.propTypes = {
  rowData: shape(),
  removeComponent: func,
};

function RowActions({ rowData, removeComponent }) {
  return (
    <div>
      <button
        onClick={() => removeComponent(rowData.uuid)}
        className="action danger"
      >
        <i className="fa-solid fa-trash" aria-hidden="true" />
      </button>
    </div>
  );
}
